import { createSlice } from "@reduxjs/toolkit";
import { fetchRefundsThunk, toggleRefundStatusThunk } from "./refundsThunk";

const initialState = {
    items: [],
    total: 0,
    totalPages: 0,
    loading: false,
    hasMore: true,
    error: null,
    page: 1,
    counts: {
        all: 0,
        pending: 0,
        refunded: 0
    }
};

export const refundsSlice = createSlice({
    name: "refunds",
    initialState,
    reducers: {
        setPage: (state, action) => {
            state.page = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchRefundsThunk.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchRefundsThunk.fulfilled, (state, action) => {
                state.loading = false;
                const data = action.payload;
                const orders = data.content;
                state.items = orders;
                state.total = data.totalElements;
                state.totalPages = data.totalPages;
                state.hasMore = !data.last;
                state.counts = data.counts;
            })
            .addCase(fetchRefundsThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(toggleRefundStatusThunk.fulfilled, (state, action) => {
                const { orderId, newStatus } = action.payload;
                state.items = state.items.map((item) => {
                    if (item.id === orderId) {
                        return { ...item, orderStatus: newStatus };
                    }
                    return item;
                });
            });
    }
});

export const { setPage } = refundsSlice.actions;
export default refundsSlice.reducer;
